<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
    <v-app-bar-nav-icon @click.stop="$store.commit('toggleDrawer', !$store.state.drawer)" />
    <v-toolbar-title style="width: 300px" class="ml-0 pl-4">{{ title }}</v-toolbar-title>
    <v-spacer />
    <v-btn icon @click.stop="logOut">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',

  props: {
    title: String,
  },

  methods: {
    logOut: function () {
      this.$store.dispatch("removeAuthToken")
      this.$router.push({ name: "sign-in" })
    }
  }
};
</script>
